'use strict';

var areaSum = require('./area-sum');

module.exports = function areaValue (h0, w0, H, W, SAT) {
  return areaSum(h0, w0, H, W, SAT) / (H * W);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/numjs/src/images/area-value.js
// module id = 242
// module chunks = 0